import React, { Component } from "react";
import {
  Chevron,
  ChevronLeft,
  ChevronLeftMD,
  ChevronRight,
  ChevronRightMD,
} from "../../normalizer";
import CustomButton from "../../shared/CustomButton";

function LeftArrow({ onClick, color }) {
  return (
    <ChevronLeft
      style={{
        fill: color,
        color: color,
      }}
      onClick={onClick}
    />
  );
}

function RightArrow({ onClick, color }) {
  return (
    <ChevronRight
      style={{
        fill: color,
        color: color,
      }}
      onClick={onClick}
    />
  );
}

export default class SliderComponent extends Component {
  static defaultProps = {
    sliderId: "sliderId",
  };

  state = {
    currentIndex: 0,
    displayedElements: undefined,
    reachedEnd: true,
    atBegining: true,
  };

  leftButtonClasses = () => {
    const { atBegining } = this.state;
    return [
      "gl-custom-slider__button",
      atBegining && "gl-custom-slider__button--hidden",
    ].join(" ");
  };

  rightButtonClasses = () => {
    const { reachedEnd } = this.state;
    return [
      "gl-custom-slider__button",
      reachedEnd && "gl-custom-slider__button--hidden",
    ].join(" ");
  };

  directionClasses = (direction) => {
    if (direction === "center") {
      return "gl-custom-slider gl-custom-slider__between";
    }
    if (direction === "start") {
      return "gl-custom-slider";
    }
    return "gl-custom-slider gl-custom-slider__between";
  };

  reachedEnd = (elements, state) =>
    state.displayedElements &&
    state.currentIndex >= elements.length - state.displayedElements;

  atBegining = (state, elements) =>
    state.currentIndex === 0 || state.displayedElements === elements.length;

  scroll = ({ toleft }) => {
    const slider = document.getElementById(this.props.sliderId);
    const elements = slider.querySelectorAll(".gl-custom-slider__item");

    const element = elements[0];

    const signal = toleft ? -1 : 1;
    this.setState(
      (state) => {
        if (!toleft && this.reachedEnd(elements, state)) {
          return {
            ...state,
            reachedEnd: true,
            atBegining: false,
          };
        }

        if (toleft && this.atBegining(state, elements)) {
          return {
            ...state,
            atBegining: true,
            reachedEnd: false,
          };
        }

        const newIndex = state.currentIndex + signal;
        const atBegining = this.atBegining(
          { currentIndex: newIndex },
          elements,
        );
        const reachedEnd = this.reachedEnd(elements, {
          ...state,
          currentIndex: newIndex,
        });
        return {
          currentIndex: state.currentIndex + signal,
          offset: element.offsetWidth * newIndex,
          atBegining,
          reachedEnd,
        };
      },
      () => {
        if (slider.scroll) {
          slider.scroll({
            left: this.state.offset,
            top: 0,
            behavior: "smooth",
          });
        } else {
          slider.scrollLeft = this.state.offset;
        }
      },
    );
  };

  resize = () => {
    // Grid mode has no slider DOM — nothing to measure
    if (!this.props.showArrows) return;

    const slider = document.getElementById(this.props.sliderId);
    if (!slider) return;

    const elements = slider.querySelectorAll(".gl-custom-slider__item");
    const element = elements[0];
    if (!element) return;

    const displayedElements = parseInt(
      (slider.offsetWidth / element.offsetWidth) % 100, //parseto int
    );
    const atBegining =
      this.state.currentIndex === 0 || this.atBegining(this.state, elements);
    const reachedEnd =
      this.reachedEnd(elements, this.state) ||
      elements.length === displayedElements;

    // Only setState when values actually changed
    if (
      this.state.displayedElements !== displayedElements ||
      this.state.atBegining !== atBegining ||
      this.state.reachedEnd !== reachedEnd
    ) {
      this.setState({ displayedElements, atBegining, reachedEnd });
    }
  };

  handleToLeftClick = () => {
    this.scroll({ toleft: true });
  };

  handleToRightClick = () => {
    this.scroll({ toleft: false });
  };

  componentDidMount() {
    this.resize();
    window.addEventListener("resize", this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  render() {
    const { children, sliderId, arrowColor, showArrows } = this.props;
    const elements = React.Children.toArray(children).map((e, i) =>
      React.cloneElement(e, {
        key: "from-slider" + i + sliderId,
      }),
    );

    // Grid / tile-wall mode (no arrows)
    if (!showArrows) {
      return (
        <div className="slider-component slider-component--grid">
          <div className="slider-component-grid">
            {elements.map((elem, idx) => (
              <div
                className="slider-component-grid-item"
                key={"grid-item-" + idx}
              >
                {elem}
              </div>
            ))}
          </div>
        </div>
      );
    }

    // Slider mode (with arrows below)
    return (
      <div className="slider-component slider-component--slider">
        <div
          className="slider-component-content gl-custom-slider__list"
          id={sliderId}
        >
          {elements.map((elem, idx) => (
            <div
              className="slider-component-slide gl-custom-slider__item"
              key={"slider-item-" + idx}
            >
              {elem}
            </div>
          ))}
        </div>
        <div className="slider-component-arrows">
          <CustomButton
            link
            large
            className="slider-component-arrow"
            onClick={this.handleToLeftClick}
          >
            <ChevronLeft color={arrowColor} />
          </CustomButton>
          <CustomButton
            link
            large
            className="slider-component-arrow"
            onClick={this.handleToRightClick}
          >
            <ChevronRight color={arrowColor} />
          </CustomButton>
        </div>
      </div>
    );
  }
}
